<template>
	<span>
		<b-nav v-if="showNav">
			<b-nav-item-dropdown id="my-nav-dropdown " text="eSim" toggle-class="nav-link-custom">
				<template slot="button-content">
					<i class="fa pr-2 fa-sim-card text-green"></i>
					<span class="nav-link-text">eSim <b class="caret"></b></span>
				</template>
	
				<slot v-for="(item, index) in links" name="title">
					<b-dropdown-item :to="item.link" :title="item.description" b-v-tooltip.hover>
						<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
						{{ item.name }}
					</b-dropdown-item>
				</slot>
			</b-nav-item-dropdown>
		</b-nav>
	</span>
</template>
<script>

export default {
  name: 'top-e-sim-dynamic-group',
  computed: {
    links() {
      return this.$store.getters["getLinksByGroup"]('eSim')
    },
    showNav() {
      return this.$store.getters["getLinksByGroup"]('eSim').length > 0
    },
  },
}
</script>
